export default __webpack_public_path__ + "static/media/action.ccacbdf5.png";